<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ typ === '+' ?'产出':'消耗' }}分布</span>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            label="排名"
            align="center"
          >
            <template v-slot:default="scope">
              <span v-if="scope.row.ridStr =='-'">合计</span>
              <span v-else>{{ scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="数量"
            align="center"
          >
            <template v-slot:default="scope">
              {{ typ === '-' ? '-':'' }} {{ scientificFormat(scope.row.num) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ridStr"
            label="来源"
            align="center"
          />
        </el-table>

        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <currencySourcesStat ref="sourceStat" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <currencySourcesRate ref="sourceRate" />
          </el-col>
        </el-row>
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { getRidTypeList } from '@/api/config/reward-record'
import currencySourcesStat from '@/views/config/user/components/user-source-stat.vue'
import currencySourcesRate from '@/views/config/user/components/user-source-rate.vue'
import { scientificFormat } from '@/utils'
export default {
  name: 'CurrencySourcesStat',
  components: {
    currencySourcesStat,
    currencySourcesRate
  },
  props: {
    typ: {
      type: String,
      default: '+'
    }
  },
  data() {
    return {
      total: 0,
      loading: false,
      tableData: []
    }
  },
  created() {
  },
  methods: {
    scientificFormat,
    refresh(data, sum) {
      const _data = JSON.parse(JSON.stringify(data))
      this.tableData = this.calculateTotal(data)
      this.$refs.sourceStat.refresh(_data)
      this.$refs.sourceRate.refresh(_data, sum)
    },
    calculateTotal(data) {
      let total = 0
      data.forEach(item => {
        total += item.num
      })
      data.push({ num: total, ridStr: '-' })
      return data
    },
    getRidData() {
      getRidTypeList().then(res => {
        this.ridData = res.data
      })
    }
  }
}
</script>

<style scoped>
</style>
